import React, { useState } from "react";
import axios from 'axios';
import ALoginpic from '../../../assets/images/admin.svg';
import '../../../assets/styles/userprofile.css';
import { useNavigate } from "react-router-dom";


function AdminLogin() {

    const [email, setemail] = useState("")
    const [password, setpassword] = useState("")
    const navigate = useNavigate();

    function sendData(e) {
        e.preventDefault();
        const newUser = {
            email: email.toLowerCase(),
            password,
        };

        axios
            .post(`${process.env.REACT_APP_API_LINK_PREFIX}api/user/login`, newUser)
            .then((res) => {

                console.log(res.data)
                if (!res.data?.isAdmin) {
                    navigate('/adminlogin')
                    alert("You are not an admin");
                }
                else if (res.data?.isAdmin) {
                    localStorage.setItem("admin", (res.data.userId))
                    localStorage.setItem("admin-token", res.data.token)
                    window.location.href = '/allusers';
                }
                else {
                    alert("Email or Password is worng");
                }
            })
            .catch((err) => {
                alert("Email or Password is worng");
                console.log(err)
            });
    }

    return (
        <section className="hero is-fullheight">
            <div className="hero-body">
                <div className="container">
                    <div className='container'>
                        <div className='columns'>
                            <div className='column is-6 mt-6'>
                                <img alt="" src={ALoginpic} />
                            </div>
                            <div className='column is-6 mt-6'>
                                <form onSubmit={sendData}>

                                    <h1 className='title is-2 has-text-centered'>Admin Login</h1>


                                    <div className='columns is-justify-content-center is-mobile mb-0'>
                                        <div className='column is-10'>
                                            <div className="field">
                                                <div className="control has-icons-left ">
                                                    <label className="label">Email</label>
                                                    <div className="control">
                                                        <input required className="input is-info" type="email" placeholder='Email' onChange={(e) => { setemail(e.target.value) }} />
                                                        <span className="icon is-small is-left">
                                                            <i className="fas fa-envelope"></i>
                                                        </span>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className='columns is-justify-content-center is-mobile mb-0'>
                                        <div className='column is-10'>
                                            <div className="field">
                                                <div className="control has-icons-left">

                                                    <label className="label">Password</label>
                                                    <div className="control">
                                                        <input required className="input is-info" type="password" placeholder='Password' onChange={(e) => { setpassword(e.target.value) }} />
                                                        <span className="icon is-small is-left">
                                                            <i className="fas fa-lock"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br></br>
                                    <div className='columns is-justify-content-center'><button type='submit' className='button is-info  but' >Login</button></div>




                                </form>
                            </div>
                        </div>
                    </div >
                </div >
            </div >
        </section>
    );

}

export default AdminLogin;

